import { defineMessages, type MessageDescriptor } from 'react-intl';

export const migrationPublishMessages: Record<
	| 'helpCenterPublished'
	| 'helpCenterPublishedDescription'
	| 'sandboxHelpCenterPublished'
	| 'sandboxHelpCenterPublishedDescription',
	MessageDescriptor
> = defineMessages({
	helpCenterPublished: {
		id: 'hub-home.help-center-layout.draft-published-success',
		defaultMessage: 'Help center published',
		description: 'Success flag title shown when draft changes are published to a help center',
	},
	helpCenterPublishedDescription: {
		id: 'hub-home.help-center-layout.draft-published-description',
		defaultMessage: 'All your changes have been published and are now visible to your audience.',
		description: 'Success flag description shown when draft changes are published to a help center',
	},
	sandboxHelpCenterPublished: {
		id: 'hub-home.help-center-layout.sandbox-draft-published-success.non-final',
		defaultMessage: 'Help center published',
		description: 'Success flag title shown when changes are published to a sandbox help center.',
	},
	sandboxHelpCenterPublishedDescription: {
		id: 'hub-home.help-center-layout.sandbox-draft-published-description.non-final',
		defaultMessage: 'Your changes have been published to this help center.',
		description:
			'Success flag description shown after publishing draft changes to a sandbox help center.',
	},
});
